import React, { useState, forwardRef, useImperativeHandle, useContext, useEffect } from "react";
import Select from "react-select";
import FilterContext from "../../utils/FilterContext";
import { id } from "date-fns/locale";
import { useLocation } from "react-router-dom";
// import AxiosInstance from "../../utils/AxiosInstance";
import { useConfig } from "../../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../../utils/AxiosInstance.jsx";


const centerTypeOptions = [
    { value: "ALL", label: "ALL", id: 1 },
    { value: "Own", label: "Own", id: 2 },
    { value: "Partnership", label: "Partnership", id: 3 },
    { value: "Franchise", label: "Franchise", id: 4 },
];

// const stateOptions = [
//     { value: "Dehradun", label: "Dehradun" },
//     { value: "Bihar", label: "Bihar" },
//     { value: "Mumbai", label: "Mumbai" },
//     { value: "Delhi", label: "Delhi" },
//     { value: "gurgaon", label: "gurgaon" },
// ];

const centerNameOptions = [
    { value: "All Centers", label: "All Centers", id: 0 },
    { value: "SAAOL Delhi Jonapur", label: "SAAOL Delhi Jonapur", id: 1 },
    { value: "SAAOL Uttarakhand Dehradun Mohitnagar", label: "SAAOL Uttarakhand Dehradun Mohitnagar", id: 38 },
    { value: "SAAOL Uttarakhand Dehradun Shivpuri", label: "SAAOL Uttarakhand Dehradun Shivpuri", id: 145 },
];
const doctorNameOptions = [
    { value: "Assistant Doctor's", label: "Assistant Doctor's", id: 1 },
    { value: "Dr. Bimal Chhajer", label: "Dr. Bimal Chhajer", id: 2 },
    { value: "All", label: "All", id: 3 },
];

const SelectDrawerFilter = forwardRef((props, ref) => {
    const [selectedCenterType, setSelectedCenterType] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCenterName, setSelectedCenterName] = useState(null);
    const [selectedDoctorName, setSelectedDoctorName] = useState(null);
    const [centers, setCenters] = useState([]);
    const { filters } = useContext(FilterContext);
    const location = useLocation();
    const currentPath = location.pathname;

    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    // Fetch centers from API
    const fetchCenters = async () => {
        try {
            const response = await AxiosInstance.get("/centers");
            if (response.data?.status && response.data?.data) {
                const centerOptions = response.data.data.map(center => ({
                    value: center.hm_name,
                    label: center.hm_name,
                    id: center.hm_id
                }));
                // Add "All Centers" option at the beginning
                // centerOptions.unshift({ value: "All Centers", label: "All Centers", id: 0 });
                setCenters(centerOptions);
            }
        } catch (error) {
            console.error("Error fetching centers:", error);
        }
    };

    // Fetch centers only when on relevant pages
    useEffect(() => {
        if (currentPath === "/center-report") {
            fetchCenters();
        }
    }, [currentPath]);


    // Initialize with saved filter values
    useEffect(() => {
        if (filters.centerName) {
            setSelectedCenterName({
                value: filters.centerName.label,
                label: filters.centerName.label,
                id: filters.centerName.id
            });
        } else {
            setSelectedCenterName(null);
        }
        if (filters.doctorName) {
            setSelectedDoctorName({
                value: filters.doctorName.label,
                label: filters.doctorName.label,
                id: filters.doctorName.id
            });
        } else {
            setSelectedDoctorName(null);
        }
        if (filters.centerType) {
            setSelectedCenterType({
                value: filters.centerType.label,
                label: filters.centerType.label,
                id: filters.centerType.id
            });
        } else {
            setSelectedCenterType(null);
        }
    }, [filters.centerName, filters.doctorName, filters.centerType]);


    // Listen for changes in the global filters and reset the corresponding local state if necessary.
    // useEffect(() => {
    //     if (!filters.centerType) {
    //         setSelectedCenterType(null);
    //     }
    //     if (!filters.state) {
    //         setSelectedState(null);
    //     }
    //     if (!filters.centerName) {
    //         setSelectedCenterName(null);
    //     }

    // }, [filters]);


    useImperativeHandle(ref, () => ({
        // Expose reset function to parent component
        resetSelections() {
            setSelectedCenterType(null);
            setSelectedState(null);
            setSelectedCenterName(null);
            setSelectedDoctorName(null)
        },
        // get function to parent component
        getSelectedData() {
            return {
                centerType: selectedCenterType ? { label: selectedCenterType.label, id: selectedCenterType.id } : null,
                // state: selectedState?.value,
                // centerName: selectedCenterName?.value,
                // center_id: selectedCenterName?.id
                centerName: selectedCenterName ? { label: selectedCenterName.label, id: selectedCenterName.id } : null,
                doctorName: selectedDoctorName ? { label: selectedDoctorName.label, id: selectedDoctorName.id } : null
            };
        }
    }));

    return (
        <div className="container mt-4">
            {/* {currentPath === "/center-report" ?
                <div className="mb-3">
                        <label className="form-label">Center Name</label>
                        <Select
                            options={centerNameOptions}
                            value={selectedCenterName}
                            onChange={setSelectedCenterName}
                            isClearable
                            isSearchable
                        />
                    </div> : ""
            } */}

            {/* <div className="mb-3">
                <label className="form-label">State</label>
                <Select
                    options={stateOptions}
                    value={selectedState}
                    onChange={setSelectedState}
                    isClearable
                    isSearchable
                />
            </div> */}

            {/* according to the path name we see a select filter */}
            {
                currentPath === "/center-report"   ?
                    <div className="mb-3">
                        <label className="form-label">Center Name</label>
                        <Select
                            options={centers}
                            value={selectedCenterName}
                            onChange={setSelectedCenterName}
                            isClearable
                            isSearchable
                            isLoading={centers.length === 0}
                            placeholder="Select a center..."
                        />
                    </div> : ""
            }
            {
                currentPath === "/doctor_revenue" ?
                    <div className="mb-3">
                        <label className="form-label">Doctors Name</label>
                        <Select
                            options={doctorNameOptions}
                            value={selectedDoctorName}
                            onChange={setSelectedDoctorName}
                            isClearable
                            isSearchable
                        />
                    </div> : ""
            }
        </div >
    );
});

export default SelectDrawerFilter;
